import { DOCUMENT_SLOTS } from './constants';
import DocumentUploadCard from './DocumentUploadCard';
import type { ScholarshipDocumentsState, ScholarshipDocumentSlot } from './types';

interface StepDocumentsProps {
  documents: ScholarshipDocumentsState;
  onSelectFile: (slot: ScholarshipDocumentSlot, file: File) => void;
  onRemove: (slot: ScholarshipDocumentSlot) => void;
  onClientError: (slot: ScholarshipDocumentSlot, error: string, file: File) => void;
  isAnyUploadInProgress: boolean;
}

export default function StepDocuments({
  documents,
  onSelectFile,
  onRemove,
  onClientError,
  isAnyUploadInProgress,
}: StepDocumentsProps) {
  return (
    <div className="space-y-6">
      {/* Title & Subtitle */}
      <div>
        <h2 className="text-xl sm:text-2xl font-bold text-[#2C2C2C] mb-2">
          المستندات المطلوبة
        </h2>
        <p className="text-sm text-[#707070] leading-relaxed">
          ارفع المستندات المطلوبة عشان فريق EduNasser يقدر يراجع طلبك.
        </p>
      </div>

      {/* 3 Upload Cards */}
      <div className="space-y-4">
        {DOCUMENT_SLOTS.map((slotItem) => (
          <DocumentUploadCard
            key={slotItem.slot}
            slot={slotItem.slot}
            title={slotItem.label}
            state={documents[slotItem.slot]}
            onSelectFile={onSelectFile}
            onRemove={onRemove}
            onClientError={onClientError}
            isAnyUploadInProgress={isAnyUploadInProgress}
          />
        ))}
      </div>

      {/* Trust & Quality Note */}
      <div className="rounded-xl border border-gray-200 bg-gray-50/70 p-3.5 text-xs text-[#707070] leading-relaxed">
        <span className="font-semibold text-[#2C2C2C]">ملاحظة: </span>
        خلي بالك الصور أو ملفات الـ PDF تكون واضحة وسارية. مش محتاج تترجم الورق في المرحلة دي.
      </div>
    </div>
  );
}
